/* @flow */

import React from 'react';
import IconHeader from 'shared/components/IconHeader';

export const Header = () => (
  <IconHeader icon="send" circular title="Messagerie" />
);



// WEBPACK FOOTER //
// ./src/modules/messaging/components/shared/Header.js